module.exports = __webpack_public_path__ + "img/img-20.d4270e19.png";